export default __webpack_public_path__ + "static/media/71ACCBE1-D196-483A-89BD-F816316919FF_1_105_c.961bb8d3.jpeg";